export default "__VITE_ASSET__D8GXToh1__"